export default {
    form: {
        serverError: 'Упс! Возникла проблема с администрированием сайта.',
        globalError: 'Пожалуйста, проверьте обязательные поля и подтвердите еще раз.',
        validateMessages: {
            default: 'Ошибка валидации для поля {errorKey}.',
            required: 'Пожалуйста, введите ваш {errorKey}.',
            email: 'Пожалуйста, введите действительный адрес электронной почты.',
            password: 'Пароль должен состоять не менее чем из 8 символов.',
            enum: '{errorKey} должен быть одним из [{enum}].',
            whitespace: '{errorKey} не может быть пустым.',
            phone: 'Пожалуйста, введите действительный {errorKey}.',
            date: {
                format: '{errorKey} имеет недопустимый формат даты.',
                parse: '{errorKey} не удалось преобразовать в дату.',
                invalid: '{errorKey} является недопустимой датой.',
            },
            string: {
                len: '{errorKey} должен содержать ровно {len} символов.',
                min: '{errorKey} должен содержать как минимум {min} символов.',
                max: '{errorKey} не может содержать больше {max} символов.',
                range: '{errorKey} должен содержать от {min} до {max} символов.',
            },
            number: {
                len: '{errorKey} должен быть равен {len}.',
                min: '{errorKey} не может быть меньше {min}.',
                max: '{errorKey} не может быть больше {max}.',
                range: '{errorKey} должен быть между {min} и {max}.',
            },
            array: {
                len: '{errorKey} должен содержать ровно {len} элементов.',
                min: '{errorKey} не может содержать менее {min} элементов.',
                max: '{errorKey} не может содержать более {max} элементов.',
                range: '{errorKey} должен содержать от {min} до {max} элементов.',
            },
            pattern: {
                mismatch: '{errorKey} не соответствует шаблону {pattern}.',
            },
        },
    },
};
//# sourceMappingURL=ru.js.map